<template>
  <div class="content">
    <Slider></Slider>
  </div>
</template>

<script>
import Slider from "@/components/Slider.vue";
import eventBus from "../eventBus";

export default {
  name: "about",
  components: {
    Slider
  },
  mounted() {
    eventBus.$emit("SLIDE_UPDATED", [
      {
        id: 0,
        quote: {
          icon: "fa fa-check",
          caption: "simplicity",
          text:
            "Simple can be harder than complex, it required a hardwork to get a clean thinking to make it simple."
        }
      },
      {
        id: 1,
        quote: {
          icon: "fa fa-drafting-compass",
          caption: "design",
          text:
            "Design is not just what it looks like and feels like. Design is how it works"
        }
      },
      {
        id: 2,
        quote: {
          icon: "far fa-paper-plane",
          caption: "creativity",
          text: "Creativity is just connecting things"
        }
      },
      {
        id: 3,
        quote: {
          icon: "far fa-gem",
          caption: "quality",
          text: "Be a yardstick of quality."
        }
      }
    ]);
  }
};
</script>
<style scoped>
html,
body {
  height: 100%;
}
.content {
  text-align: center;
  padding: 20px;
}
</style>
